import { AxiosResponse } from 'axios';
import { UDNICK } from '../../../../service/udnick';
import { IFilter } from 'store/ducks/atendimentos/types';

export const listaAtendimento = {
  getAllData: (
    centroDistribuicao: number | undefined,
    fitro: IFilter | undefined,
    inscricoesEstaduais: number | undefined,
    tamanhoPagina: number | undefined
  ): Promise<AxiosResponse> =>
    UDNICK.callService(
      'getOcorrencias',
      { centroDistribuicao, fitro, inscricoesEstaduais },
      { tamanhoPagina }
    ),
};

export const listaAtendentes = {
  listaAtendentes: (): Promise<AxiosResponse> => UDNICK.callService('listaAtendentes'),
};

export const listaDepartamentos = {
  listaDepartamentos: (): Promise<AxiosResponse> => UDNICK.callService('listaDepartamentos'),
};
